import { classnames } from '@/helpers';
import { IconProps, IconSize, IconVariant } from './types';

const getImageNameWithCacheBreaker = (variant: IconVariant) => {
  switch (variant) {
    case 'phone':
      return 'phone2';
    default:
      return variant;
  }
};

const ICON_SIZE_STYLE_MAP: {
  [key in IconSize]: {
    width: number;
    height: number;
  };
} = {
  xxxs: { width: 9, height: 9 },
  xxs: { width: 12, height: 12 },
  xs: { width: 16, height: 16 },
  sm: { width: 24, height: 24 },
  md: { width: 32, height: 32 },
  lg: { width: 48, height: 48 },
};

const Icon = ({ variant, color = 'black-900', className = '', size = 'sm', noFilter = false, ...props }: IconProps) => {
  /**
   * Prefix 'filter_' is used to apply CSS filter classes for coloring SVG icons
   * If color does not show, make sure the corresponding filter exists in
   * src/colors for filterColors constant
   */
  const filterColor = `filter_${color}`;

  return (
    <img
      src={`/images/icons/${getImageNameWithCacheBreaker(variant)}.svg`}
      {...props}
      style={{ ...ICON_SIZE_STYLE_MAP[size], ...props.style }}
      className={classnames(noFilter ? '' : filterColor, className)}
      alt={props.alt ?? ''}
    />
  );
};

export default Icon;
